<template>
  <div class="top-back-nav">
    <div class="room-nav-back">
          <img src="@/assets/live/back_icon.png" @click="backClick" />
          <span class="course-title">
            {{Navtitle}}
          </span>
    </div>
    <div class="line"></div>
  </div>

</template>

<script>
export default {
  name: 'TopBackNav',
  props: ['Navtitle'],
  data () {
    return {

    }
  },
  methods: {
    backClick: function () {
      this.$emit('backClick')
    }
  }
}

</script>

<style>

  .top-back-nav{
    padding: 10px;
  }
  .room-nav-back{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .room-nav-back img{
    width: 20px;
    cursor: pointer;
  }

  .room-nav-back span{
    color: #4A4A4A;
    font-size: 18px;
    margin-left: 20px;
  }

 .line{
    height: 1px;
    width: 100%;
    border-bottom: 1px solid #cccccc;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/userinfo/TopBackNav.vue